import { DropdownTrigger } from 'components/DropdownTrigger/DropdownTrigger'
import { LocationPicker, Props as LocationPickerProps } from 'components/LocationPicker/LocationPicker'
import { DropdownTriggerProps } from 'components/DropdownTrigger/Types'
import Styles from './InlineLocationPicker.module.scss'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { Button } from 'blaze-ui/Button'
import { ButtonProps } from 'blaze-ui/Button/Types'
import { Folder } from 'blaze-ui/icons'
import { LocationPickerDrawer } from 'components/LocationPicker/LocationPickerDrawer'
import { useRootStore } from 'stores/RootStore'
import { observer } from 'mobx-react-lite'
import { FormButton } from 'components/Wizards/Wizard/FormButton/FormButton'

export interface InlineLocationPickerProps
  extends Pick<ButtonProps, 'isDisabled' | 'size' | 'variant' | 'withChevron' | 'fullWidth'> {
  locationPickerProps: LocationPickerProps
  dropdownTriggerProps: Omit<DropdownTriggerProps, 'children'>
  buttonLabel: string
  isRootDisabled?: boolean
  triggerComponent?: 'button' | 'formButton'
}

export const InlineLocationPicker = observer(
  ({
    dropdownTriggerProps,
    locationPickerProps,
    buttonLabel,
    isDisabled,
    size = 'md',
    variant = 'tertiary',
    withChevron,
    isRootDisabled = true,
    fullWidth = false,
    triggerComponent = 'button',
  }: InlineLocationPickerProps) => {
    const { onSelectFolder } = locationPickerProps
    const { isMobile } = useResponsiveDesign()
    const { drawersStore } = useRootStore()

    if (isMobile) {
      return (
        <>
          {triggerComponent === 'button' ? (
            <Button
              data-testid="location-picker-drawer-button"
              variant={variant}
              size={size}
              withChevron={withChevron}
              frontIcon={Folder}
              isDisabled={isDisabled}
              fullWidth={fullWidth}
              onPress={() => drawersStore.openDrawer(LocationPickerDrawer, { ...locationPickerProps })}
            >
              <span className={Styles.buttonLabel}>{buttonLabel}</span>
            </Button>
          ) : (
            <FormButton
              data-testid="location-picker-drawer-button"
              variant={variant}
              icon={Folder}
              isDisabled={isDisabled}
              onPress={() => drawersStore.openDrawer(LocationPickerDrawer, { ...locationPickerProps })}
            >
              <span className={Styles.buttonLabel}>{buttonLabel}</span>
            </FormButton>
          )}
        </>
      )
    }

    return (
      <DropdownTrigger {...dropdownTriggerProps}>
        {triggerComponent === 'button' ? (
          <Button
            variant={variant}
            fullWidth={fullWidth}
            size={size}
            withChevron={withChevron}
            frontIcon={Folder}
            isDisabled={isDisabled}
          >
            <span className={Styles.buttonLabel}>{buttonLabel}</span>
          </Button>
        ) : (
          <FormButton icon={Folder} isDisabled={isDisabled}>
            <span className={Styles.buttonLabel}>{buttonLabel}</span>
          </FormButton>
        )}
        {(close) => (
          <LocationPicker
            {...locationPickerProps}
            isRootDisabled={isRootDisabled}
            onSelectFolder={(destination) => {
              onSelectFolder(destination)

              close()
            }}
          />
        )}
      </DropdownTrigger>
    )
  },
)
